const Skeleton = ({ type }) => {
  return (
    <div className="ff--skeleton__placeholder ff--skeleton__placeholder--flex" />
  );
};

export default Skeleton;
